angular.module('controllers').controller('discountController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout',
    function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout) {
		$rootScope.path = '/discount';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'discount';
		$scope.pathTemplate = 'discounts/discounts';
		$scope.title = 'Reduceri';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'discount_name';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'discount_name':{'label':'Nume discount', 'filter':1, 'filterType':'input'},
            'discount_type_id':{'label':'Tip discount', 'filter':1, 'filterType':'select'},
			'discount_value':{'label':'Valoare discount', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

        $scope.additionals['discount_types'] = [
            {'id':'', 'value' : ''},
            {'id':0, 'value' : 'procent'},
            {'id':1, 'value' : 'suma fixa'},
            {'id':2, 'value' : 'customizat'}

        ];

        $scope.columns.discount_type_id.options = $scope.additionals['discount_types'];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'discount_name';

		$scope.additionals['functionResult']= function(ev, data) {
			if (!angular.isUndefined($scope.modelData.discount_name)) {
				$scope.modelData.discount_name = $scope.modelData.discount_name.toLowerCase();
			}
			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].discount_name)) {
						$scope.modelsData[key].discount_name = $scope.modelsData[key].discount_name.toLowerCase();
					}
				});
			}
		}

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };


	}]
);
